export function printDebugConsole(response) {
    const { db_requests, db_requests_count, db_requests_time } = response.data._debug.database;

    if (db_requests_count > 0) {
        const method = response.config.method.toUpperCase();
        const url = response.config.url;
        const status = response.status;

        const greyColor = '#95a5a6';
        const greenColor = '#27ae60';
        const orangeColor = '#f39c12';
        const blueColor = '#3498db';
        const redColor = '#e74c3c';

        const methodColors = {
            GET: greenColor,
            POST: orangeColor,
            PUT: blueColor,
            DELETE: redColor,
        };
        const methodColor = methodColors[method] || greyColor;

        console.groupCollapsed(
            `%c ${method} %c ${url} %c ${status} %c ${db_requests_count} queries in ${db_requests_time}`,
            `background: ${methodColor}; color: white; padding: 2px 5px; border-radius: 3px; font-weight: bold;`,
            'font-weight: bold;',
            `color: ${status < 400 ? greenColor : redColor}; font-weight: bold;`,
            `color: ${greyColor}; font-weight: normal; font-style: italic;`,
        );

        db_requests.forEach(request => {
            const sql = request.sql.trim();
            const isCall = /^(exec)\b/i.test(sql);
            const isSelect = /^(select)\b/i.test(sql);

            let label = { text: 'SQL', color: greyColor };
            if (isCall) label = { text: 'EXEC', color: blueColor };
            else if (isSelect) label = { text: 'SELECT', color: greenColor };
            else if (/^(update|insert|delete)\b/i.test(sql)) label = { text: 'WRITE', color: orangeColor };

            let shortSql = request.sql.split('\n')[0].trim();
            shortSql = shortSql.length > 40 ? shortSql.slice(0, 40) + '...' : shortSql;

            console.info(
                `%c ${label.text} %c %s`,
                `color: white; background: ${label.color}; padding: 1px 4px; border-radius: 3px; font-size: 10px;`,
                `font-weight: normal; margin-left: 5px;`,
                shortSql,
            );

            console.log('%c Full Query:', `font-weight: bold;`, request.sql);
            console.log('%c Bindings:', `font-weight: bold;`, request.bindings);
            console.log('%c Time:', `font-weight: bold;`, request.time);
        });

        console.groupEnd();
    }

    delete response.data._debug;
}
